import { render, staticRenderFns } from "./AnonymisationReview.vue?vue&type=template&id=175e2bc7&"
import script from "./AnonymisationReview.vue?vue&type=script&lang=ts&"
export * from "./AnonymisationReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports